export { default } from './OrderItemsCart'



// WEBPACK FOOTER //
// ./src/App/components/OrderItemsCart/index.js